import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import web5 from "../img/Outsourcing.jpg";
import "../style/styles.css";
import "../style/Outsourcing.css";

const Outsourcing = () => {
  const AltText = "Photo";

  const outsourcingText =
    "In the current global economic era, outsourcing is now a crucial component of all organizations. Unlike in the past, outsourcing is now a primary business strategy for companies, giving them a competitive edge, rather than just a way to cut operating costs. It allows them to focus on their core skills while letting their intellectual resources contribute to the accomplishment of organizational goals and objectives. Software outsourcing firm EBS Software, situated in India, specializes in offshore software development that is highly efficient, timely, and reasonably priced.Our extensive and diverse experience in offshore software development, coupled with our strict quality standards and project management skills, guarantee that we will create solutions that will set your company apart from the competition. Our worldwide software outsourcing approach ensures that we give you the best possible outcome.";

  const highlights = [
    {
      value: "Offshore",
      label: "Software Development",
    },
    {
      value: "Quality",
      label: "Strict Standards",
    },
    {
      value: "Timely",
      label: "Project Delivery",
    },
    {
      value: "Cost",
      label: "Reasonably Priced",
    },
  ];

  const serviceCards = [
    {
      title: "Business Strategy Support",
      text:
        "Outsourcing is now a primary business strategy that helps companies gain competitive edge, not only reduce operating costs.",
    },
    {
      title: "Focus on Core Skills",
      text:
        "It allows companies to focus on their core skills while intellectual resources contribute to organizational goals and objectives.",
    },
    {
      title: "Offshore Software Development",
      text:
        "EBS Software specializes in offshore software development that is highly efficient, timely and reasonably priced.",
    },
    {
      title: "Quality & Project Management",
      text:
        "Our diverse experience, strict quality standards and project management skills help create solutions that set your company apart.",
    },
  ];

  const processItems = [
    "Understand outsourcing requirements and business goals",
    "Plan offshore software development approach",
    "Apply strict quality standards",
    "Use project management skills for timely delivery",
    "Create efficient and reasonably priced software solutions",
    "Deliver the best possible outcome through global outsourcing approach",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="outsourcing-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Software Outsourcing | EBS Software Solution</title>
        <meta
          name="description"
          content="Software outsourcing by EBS Software Solution, India. Offshore software development with efficient, timely and reasonably priced solutions, strict quality standards and project management skills."
        />
      </Helmet>

      <section className="outsourcing-hero">
        <div className="outsourcing-hero-overlay"></div>

        <Container className="outsourcing-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="outsourcing-hero-content">
                <div className="outsourcing-kicker">Offshore Software Development</div>
                <h1>Software Outsourcing</h1>
                <p>
                  In the current global economic era, outsourcing is now a
                  crucial component of all organizations and a primary business
                  strategy for companies.
                </p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="outsourcing-hero-card">
                <span>Global Outsourcing Approach</span>
                <strong>Efficient, timely and reasonably priced development</strong>
                <p>
                  EBS Software helps companies focus on core skills while
                  delivering quality offshore software development solutions.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="outsourcing-stats-section">
        <Container>
          <Row className="g-3">
            {highlights.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="outsourcing-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="outsourcing-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="outsourcing-section-label">Overview</div>
              <h2 className="outsourcing-section-title">
                Offshore development that supports business growth
              </h2>

              <p className="outsourcing-text">
                Unlike in the past, outsourcing is now a primary business
                strategy for companies, giving them a competitive edge, rather
                than just a way to cut operating costs.
              </p>

              <p className="outsourcing-text">
                It allows them to focus on their core skills while letting their
                intellectual resources contribute to the accomplishment of
                organizational goals and objectives.
              </p>
            </Col>

            <Col lg={6}>
              <div className="outsourcing-image-card">
                <img
                  className="outsourcing-main-image"
                  src={web5}
                  alt={AltText}
                  onError={handleImageError}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="outsourcing-content-section">
        <Container>
          <Row className="g-4 align-items-stretch">
            <Col lg={7}>
              <div className="outsourcing-content-card">
                <div className="outsourcing-section-label">Complete Information</div>
                <h2>Software Outsourcing</h2>
                <p>{outsourcingText}</p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="outsourcing-service-grid">
                {serviceCards.map((item) => (
                  <div className="outsourcing-service-card" key={item.title}>
                    <span>✓</span>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="outsourcing-process-section">
        <Container>
          <div className="outsourcing-process-card">
            <Row className="g-4 align-items-center">
              <Col lg={5}>
                <div className="outsourcing-section-label">Our Approach</div>
                <h2>Strict quality standards with project management skills</h2>
                <p>
                  Our extensive and diverse experience in offshore software
                  development helps us create solutions that set your company
                  apart from the competition.
                </p>
              </Col>

              <Col lg={7}>
                <div className="outsourcing-process-list">
                  {processItems.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Outsourcing;
